import React from "react";
import styled from "styled-components";
import { Link } from "react-router-dom";
import { CardContainer, CardBody, CardTop, CardYear } from "./Card";
import { GlobalProjectModal } from "../Experiences/Alumni";
import PropTypes from "prop-types";
import GEbig from "../../Images/min-Globe.jpg";
import GEsmall from "../../Images/max-Globe.jpg";
import TimReviewbig from "../../Images/min-TIMReview.jpg";
import TimReviewsmall from "../../Images/max-TIMReview.jpg";
import BBBbig from "../../Images/min-BBB.jpg";
import BBBsmall from "../../Images/max-BBB.jpg";
import GERSbig from "../../Images/max-GERS.jpg";

import "./index.css";
import { faCalculator } from "@fortawesome/free-solid-svg-icons";

const networkGlobal = [
  {
    name: "TIM Review",
    subText: "30,000 unique readers/month",
    year: "2007",
    note: "Network of academics and practitioners producing peer reviewed articles",
    url: "https://timreview.ca",
    banner: {
      big: TimReviewbig,
      small: TimReviewsmall,
    },

  },
  {
    name: "BigBlueButton",
    subText: "Best web conferencing system for online learning",
    year: "2008",
    note: "Network of contributors and customers of open source software",
    url: "https://bigbluebutton.org",
    banner: {
      big: BBBbig,
      small: BBBsmall,
    },
  },
  {
    name: "Global EPIC",
    subText: "25 cybersecurity keystones worldwide",
    year: "2017",
    note: "Network of keystones that collaborate globally to benefit their local communities",
    url: "https://globalepic.org",
    banner: {
      big: GEbig,
      small: GEsmall,
    },
  },
  {
    name: "Global GERS",
    subText: "Global support to grow local ventures",
    year: "2018",
    note: "Ecosystem of entrepreneurs, trainers, universities, regional innovation centres, investment firms, municipalities, service providers",
    url: "/ecosystem-charter",
    banner: {
      big: GERSbig,
    },
    internal: true,
  }
];

const CardHref = styled.a`
  vertical-align: top;
  overflow: hidden;
  position: relative;
  display: flex;
  flex-direction: column;
  min-width: 0;
  word-wrap: break-word;
  background-clip: border-box;
  text-align: ${props => props.theme.textAlign};
  height: ${props => props.theme.height};
  max-height: ${props => props.theme.maxHeight};
  background-color: ${props => props.theme.backColor};
  box-shadow: ${props => props.theme.boxShadow};
  border-radius: ${props => props.theme.borderRadius};
  border-top: ${props => props.theme.borderTop};

  &:hover {
    text-decoration: none;
    color: ${props => props.theme.textHoverColor};
  }
 @media (max-width: 600px) {
    height: ${props => `calc(${props.theme.height} - 40px)`};
  }
`;

//Duplicated as the above now. to merge in 'styled-components v4' 
//using the 'as={Link}|| as="a"' attribute
const CardLink = styled(Link)`
  vertical-align: top;
  overflow: hidden;
  position: relative;
  display: flex;
  flex-direction: column;
  min-width: 0;
  word-wrap: break-word;
  background-clip: border-box;
  text-align: ${props => props.theme.textAlign};
  height: ${props => props.theme.height};
  max-height: ${props => props.theme.maxHeight};
  background-color: ${props => props.theme.backColor};
  box-shadow: ${props => props.theme.boxShadow};
  border-radius: ${props => props.theme.borderRadius};
  border-top: ${props => props.theme.borderTop};

  &:hover {
    text-decoration: none;
    color: ${props => props.theme.textHoverColor};
  }
  @media (max-width: 600px) {
    height: ${props => `calc(${props.theme.height} - 40px)`};
  }
`;

//Render card grid sizes as specified 
const CardGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(${props => props.minCardWidth}, ${props => props.maxCardWidth}));
  grid-gap: ${props => props.cardGap};
`;

//default card theme - used for local cards (Our portfolio of global initiatives)
const defaultCardTheme = {
  textAlign: "center",
  height: "338px",
  maxHeight: "342px",
  backColor: "#f9f7f7",
  boxShadow: "8px 10px 20px 0 rgba(47, 63, 77, 0.15)",
  borderRadius: "0.25rem",
  borderTop: "6px solid hsl(217, 53%, 17%)",
  textHoverColor: "hsl(0, 0%, 16%)",
};

//main card component. call this with the required arguments
class GlobalNetwork extends React.Component { 
  constructor(props) {
    super(props);
    this.state = {
      isModal: false
    }
    this.handleModalOpen = this.handleModalOpen.bind(this);
  }
  //Toggle modal open/close state. Modal integrated using react-modal only
  handleModalOpen() {
    this.setState((prevState) => ({isModal: !prevState.isModal}));
  }

  render() {
    const { 
      title="Our portfolio of global initiatives", 
      minCardWidth="200px", 
      maxCardWidth="1fr", 
      cardGap="10px", 
      cardBodyPad="0 8px 10px",
      bgColor="white",
      cards=networkGlobal, 
      theme=defaultCardTheme,
      ...props 
    } = this.props;
  let keyVal=0;
  return (
    <CardContainer title={title} bgColor={bgColor}>
      <CardGrid 
        minCardWidth={minCardWidth} 
        maxCardWidth={maxCardWidth} 
        cardGap={cardGap} 
        className="flex--center">
        {
        cards && cards.map(card => (
        card.internal  ? 
        <InternalCard theme={theme} cardBodyPad={cardBodyPad} cardList={card} key={keyVal++} showModal={!!card.showModal} makeModal={this.handleModalOpen}  /> :
        <ExternalCard theme={theme} cardBodyPad={cardBodyPad} cardList={card} key={keyVal++} showModal={!!card.showModal} makeModal={this.handleModalOpen} /> 
        ))
        }
      </CardGrid>
      { props.haveButton && props.haveButton }
      { this.state.isModal && <GlobalProjectModal isModalOpen={this.state.isModal} handleModalOpen={this.handleModalOpen} />}
      
    </CardContainer>
  );
  }  
}

GlobalNetwork.propTypes = {
  title: PropTypes.string,
  minCardWidth: PropTypes.string,
  maxCardWidth: PropTypes.string,
  cardGap: PropTypes.string,
  cardBodyPad: PropTypes.string,
  cards: PropTypes.array,
  theme: PropTypes.object,
}


// Render as react-router link
function InternalCard(props) {
  const {url, name, banner, year, subText} = props.cardList;
  console.log('internal: ', props.showModal);
  return (
    <CardLink theme={props.theme} to={url} key={name} onClick={props.showModal ? props.makeModal: undefined}>
      <CardTop name={name} banner={banner} />
      {
        year && <CardYear year={year} />
      }      
      <CardBody name={name} subText={subText} cardBodyPad={props.cardBodyPad} />  
    </CardLink>
  );
}

//Render as html <a> link
function ExternalCard(props) {
  const {url, name, banner, year, subText} = props.cardList;
  console.log('external: ', props.showModal);
  return (
    <CardHref theme={props.theme} href={url} target="_blank" rel="noopener noreferrer" key={name} onClick={props.showModal ? props.makeModal: undefined}>
      <CardTop name={name} banner={banner} />
      {
        year && <CardYear year={year} />
      }
      <CardBody name={name} subText={subText} cardBodyPad={props.cardBodyPad} />
    </CardHref>
  );
}


export { GlobalNetwork, InternalCard, ExternalCard }





// WEBPACK FOOTER //
// ./src/Components/Networks/index.js